import { ChakraBox, ActionBar, FAIconName } from '@equip.health/ui';
import { useHistory } from 'react-router-dom';
import {
  LAB_ORDER_SUCCESS_MESSAGE,
  VIEW_LABS_TEXT,
} from '~/lib/constants/patients.constants';
import { Path } from '~/routes/constants';

interface LabOrderActionBarProps {
  patientId: string;
  onHide: () => void;
}

const LabOrderActionBar = ({ patientId, onHide }: LabOrderActionBarProps) => {
  const history = useHistory();

  const handleViewLabsClick = () => {
    onHide();
    history.push(`${Path.MAUD_PATIENTS}/${patientId}/labs`);
  };

  return (
    <ChakraBox
      bottom="20px"
      left="50%"
      maxWidth="90%"
      position="fixed"
      transform="translateX(-50%)"
      width="330px"
      zIndex={9999}
    >
      <ActionBar
        barIcon={FAIconName.checkRegular}
        buttonIcon={FAIconName.rectangleVerticalHistoryRegular}
        buttonText={VIEW_LABS_TEXT}
        id="lab-order-created"
        onButtonClick={handleViewLabsClick}
        size="small"
        text={LAB_ORDER_SUCCESS_MESSAGE}
        textPlacement="start"
        variant="primary"
      />
    </ChakraBox>
  );
};

export default LabOrderActionBar;
